import { graphql } from '@/gql';
import { CallType } from '@/models/callLog';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateLiveCallCallType = async (callLogId: number, callType: CallType) => {
  console.log('updateLiveCallCallType', callLogId, callType);

  const response = await mutationExecute({
    mutation: graphql(`
      mutation updateLiveCallCallType($callLogId: Float!, $callType: String!) {
        updateLiveCallCallType(id: $callLogId, callType: $callType) {
          id
          callType
        }
      }
    `),
    variables: {
      callLogId,
      callType,
    },
  });

  return response.data!.updateLiveCallCallType;
};
